import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/Data.context";
import { useNavigate, useParams } from "react-router-dom";
import { ConfirmContext, Separator } from "@moreirapontocom/npmhelpers";

const ReaderDetails = () => {
  const navigate: any = useNavigate();
  const { data, setData } = useContext(DataContext);
  const { setConfirm } = useContext(ConfirmContext);
  const params: any = useParams();
  const readerHashId: string = params.readerHashId;

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Reader Details",
        backButton: true,
        previousPage: "/readers",
        actionButton: true,
        nextPage: () => reader && <DeleteReaderButton />,
      },
    });

    _getReaderDetails();
  }, []);

  const DeleteReaderButton = () => {
    return <>
      <button
        onClick={() => 
          setConfirm({
              type: "danger",
              title: "Delete Reader",
              message: "Are you sure you want to delete this reader?",
              buttonLabel: "Confirm Delete",
              buttonCancelLabel: "Cancel",
              onConfirm: () => _deleteReader(),
          })}
        type="button"
        className="btn btn-outline-secondary btn-inline btn-sm">
          <i className="fas fa-trash-alt text-white"></i>
      </button>
    </>
  };

  const [reader, setReader] = useState({} as any);
  const _getReaderDetails = () => {
    const storageKey = "readers";
    const readersStorage: any = localStorage.getItem(storageKey);
    if (!readersStorage) {
      return;
    }

    const readers: any = JSON.parse(readersStorage);
    const reader: any = readers.find((reader: any) => reader.hashId === readerHashId);
    setReader(reader);
  };

  const _deleteReader = () => {
    const storageKey = "readers";
    const readersStorage: any = localStorage.getItem(storageKey);
    if (!readersStorage) {
      return;
    }

    const readers: any = JSON.parse(readersStorage);
    const newReaders: any = readers.filter((reader: any) => reader.hashId !== readerHashId);
    localStorage.setItem(storageKey, JSON.stringify(newReaders));
    navigate("/readers");
    return;
  };

  return <>
    <div className="row text-center justify-content-center">
      <div className="col-5">
        <img src="/images/reader-white-light.png" alt="" className="img-fluid" />
      </div>
    </div>

    <Separator size={20} />

    <div className="text-center">
      <h3>
        <strong>{reader.name || ""}</strong>
      </h3>

      <Separator size={20} />

      Firmware Version: <strong>{reader.firmwareVersion || ""}</strong><br />
      Serial Number: <strong>{reader.serialNumber || ""}</strong>

      <Separator size={40} />

      <span className="text-danger">Update Required</span>

      <Separator size={10} />

      <button
        onClick={() => navigate("/home")}
        type="button"
        disabled
        className="btn btn-outline-primary">
          Update Firmware (Work in Progress)
      </button>
    </div>
  </>
};

export default ReaderDetails;